
      export const versions = {
        commit: '5f09526c057b198521ede11dd93c0446020abebf',
        branch: 'HEAD'
      };
